import {Component, LOCALE_ID} from '@angular/core';
import { OfferFormComponent } from "../offer-form/offer-form.component";
import { ClrIconModule } from "@clr/angular";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { JsonPipe, NgIf } from "@angular/common";
import { Offers } from "../../../_shared/interfaces";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { AlertService, IAlertType, OffersStoreService } from "../../../_shared/services";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-offer-update',
  standalone: true,
  imports: [
    OfferFormComponent,
    ClrIconModule,
    RouterLink,
    NgIf,
    JsonPipe
  ],
  templateUrl: './offer-update.component.html',
  styleUrl: './offer-update.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de' }]
})
export class OfferUpdateComponent {
  projectId: string = '';
  offerId: number = 0;
  offers: Offers[] = [];

  devMode: boolean;

  constructor(
    private offss: OffersStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute,
    ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }


  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.offerId = parseInt(params.get('offid') ?? '');
    this.loadOffer(this.projectId, this.offerId);
  }

  loadOffer(prid: string, reqid: number) {
    this.offss.getOffers(prid, reqid, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Offerdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }

        this.offers = data.object;
        if (this.devMode) console.table(this.offers[0]);

      },
      complete: () => {},
      error: () => {
        return;
      }
    });
  }
}
